<!--
  Inc 36: este componente ya NO pinta KPIs. La pestaña "Métricas" del detalle es
  la fuente única de los números (Entrega + Engagement) y este componente queda
  como la TABLA DE DESTINATARIOS que vive debajo de esos KPIs.
  El resumen con los getters sum* se conserva como FALLBACK: solo se pinta si las
  métricas autoritativas del backend no llegaron (getMetrics falló), caso en el
  que los KPIs de arriba muestran "—" y estos conteos de la página cargada son
  la única información disponible.
-->
<div class="shipping-view">
  <!-- Filters Row (mismo layout que /tab=analyze) -->
  <div class="mb-6 flex flex-wrap items-center justify-between gap-4">
    <div class="flex flex-wrap items-center gap-4">
      <div class="flex items-center gap-2">
        <label class="text-sm text-gray-600 dark:text-gray-400">Estado:</label>
        <select [(ngModel)]="statusFilter" (change)="setStatusFilter(statusFilter)"
                class="px-3 py-2 text-sm rounded-md bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 dark:text-white min-w-[160px]">
          <option value="ALL">Todos</option>
          @for (s of statuses; track s) {
            <option [value]="s">{{ recipientStatusLabel(s) }}</option>
          }
        </select>
      </div>
      <div class="flex items-center gap-2">
        <label class="text-sm text-gray-600 dark:text-gray-400">Buscar:</label>
        <input type="text" [(ngModel)]="searchTerm" placeholder="email o nombre…"
               class="px-3 py-2 text-sm rounded-md bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 dark:text-white w-64" />
      </div>
    </div>
    <div class="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
      Mostrando <strong>{{ rows.length }}</strong> de <strong>{{ totalElements }}</strong>
    </div>
  </div>

  @if (error) {
    <div class="mb-4 rounded-lg bg-red-50 dark:bg-red-900/20 p-3 text-sm text-red-700 dark:text-red-300">
      {{ error }}
    </div>
  }

  @if (loading && rows.length === 0) {
    <div class="flex justify-center py-20">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 dark:border-white"></div>
    </div>
  } @else {
    <div class="space-y-6">

      <!-- FALLBACK: solo si las métricas autoritativas no están disponibles (Inc 36).
           Con métricas presentes, los KPIs los pinta la pestaña "Métricas" (arriba). -->
      @if (!hasAuthoritativeMetrics) {
      <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">Resumen de envío</h2>

        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          <div class="text-center p-4 rounded-lg bg-gray-50 dark:bg-gray-700/50">
            <div class="text-3xl font-bold text-gray-900 dark:text-white">{{ sumTotal | number }}</div>
            <div class="text-sm text-gray-500 dark:text-gray-400 mt-1">Destinatarios</div>
          </div>
          <div class="text-center p-4 rounded-lg bg-gray-50 dark:bg-gray-700/50">
            <div class="text-3xl font-bold text-gray-500 dark:text-gray-300">{{ sumPending }}</div>
            <div class="text-sm text-gray-500 dark:text-gray-400 mt-1">Pendientes</div>
          </div>
          <div class="text-center p-4 rounded-lg bg-gray-50 dark:bg-gray-700/50">
            <div class="text-3xl font-bold text-blue-600 dark:text-blue-400">{{ sumQueued }}</div>
            <div class="text-sm text-gray-500 dark:text-gray-400 mt-1">Encolados</div>
          </div>
          <div class="text-center p-4 rounded-lg bg-gray-50 dark:bg-gray-700/50">
            <div class="text-3xl font-bold text-teal-600 dark:text-teal-400">{{ sumSent }}</div>
            <div class="text-sm text-gray-500 dark:text-gray-400 mt-1">Enviados</div>
          </div>
          <div class="text-center p-4 rounded-lg bg-gray-50 dark:bg-gray-700/50">
            <div class="text-3xl font-bold text-red-600 dark:text-red-400">{{ sumFailed }}</div>
            <div class="text-sm text-gray-500 dark:text-gray-400 mt-1">Fallidos</div>
          </div>
          <div class="text-center p-4 rounded-lg bg-gray-50 dark:bg-gray-700/50">
            <div class="text-3xl font-bold text-amber-600 dark:text-amber-400">{{ sumSkipped }}</div>
            <div class="text-sm text-gray-500 dark:text-gray-400 mt-1">Saltados</div>
          </div>
        </div>
        <div class="mt-4 grid grid-cols-2 md:grid-cols-4 gap-4">
          <div class="text-center p-3 rounded-lg bg-gray-50 dark:bg-gray-700/50">
            <div class="text-2xl font-bold text-green-600 dark:text-green-400">{{ sumOpened }}</div>
            <div class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Abrieron · {{ sumOpenRate }}%</div>
          </div>
          <div class="text-center p-3 rounded-lg bg-gray-50 dark:bg-gray-700/50">
            <div class="text-2xl font-bold text-violet-600 dark:text-violet-400">{{ sumClicked }}</div>
            <div class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Click · {{ sumClickRate }}%</div>
          </div>
          <div class="text-center p-3 rounded-lg bg-gray-50 dark:bg-gray-700/50">
            <div class="text-2xl font-bold text-red-600 dark:text-red-400">{{ sumBounced }}</div>
            <div class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Rebotaron</div>
          </div>
          <div class="text-center p-3 rounded-lg bg-gray-50 dark:bg-gray-700/50">
            <div class="text-2xl font-bold text-blue-600 dark:text-blue-400">{{ sumDelivered }}</div>
            <div class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Entregados</div>
          </div>
        </div>
        <p class="mt-3 text-xs text-gray-400">
          No se pudieron cargar las métricas del correo: estos conteos se calculan sobre los
          {{ rows.length }} destinatarios cargados. Cambia el filtro de estado para ver más.
        </p>
      </div>
      }

      <!-- Lista de destinatarios -->
      <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
        <div class="mb-4 flex items-center justify-between gap-2">
          <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Destinatarios</h2>
          <span class="text-xs text-gray-400">Click en un destinatario para ver el timeline de eventos</span>
        </div>

        @if (filteredRows.length === 0) {
          <div class="flex flex-col items-center justify-center py-12 text-gray-400">
            <svg class="w-12 h-12 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <p class="text-sm">
              @if (totalElements === 0) {
                Este correo aún no tiene destinatarios.
              } @else {
                Sin resultados con esos filtros.
              }
            </p>
          </div>
        } @else {
          <div class="space-y-2">
            @for (row of filteredRows; track row.id) {
              <div class="rounded-lg border border-gray-200 dark:border-gray-700 transition-colors hover:border-gray-300 dark:hover:border-gray-600">
                <div (click)="toggleExpand(row)" class="flex cursor-pointer items-center gap-3 p-4">
                  <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-gray-200 text-sm font-medium text-gray-700 dark:bg-gray-700 dark:text-gray-300">
                    {{ initialsOf(row.fullName, row.email) }}
                  </div>
                  <div class="flex-1 min-w-0">
                    <div class="flex flex-wrap items-center gap-2">
                      <span class="rounded-full px-2 py-0.5 text-[10px] font-medium" [class]="recipientStatusBadge(row.recipientStatus)">
                        {{ recipientStatusLabel(row.recipientStatus) }}
                      </span>
                      @if (isExclusionError(row.recipientError)) {
                        <span class="rounded-full px-2 py-0.5 text-[10px] font-medium bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300"
                              [title]="exclusionTooltip(row.recipientError)">
                          {{ exclusionLabel(row.recipientError) }}
                        </span>
                      }
                      @if (row.emailStatus) {
                        <span class="rounded-full px-2 py-0.5 text-[10px] font-medium" [class]="emailStatusBadge(row.emailStatus)">
                          {{ emailStatusLabel(row.emailStatus) }}
                        </span>
                      }
                      <p class="truncate text-sm font-medium text-gray-900 dark:text-white">
                        @if (row.fullName) { {{ row.fullName }} · } {{ row.email }}
                      </p>
                    </div>
                    <div class="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-gray-500 dark:text-gray-400">
                      @if (row.deliveredAt) { <span>✅ {{ formatDate(row.deliveredAt) }}</span> }
                      @if ((row.openCount ?? 0) > 0) {
                        <span class="text-green-600 dark:text-green-400">👁 {{ row.openCount }} apertura{{ (row.openCount ?? 0) > 1 ? 's' : '' }}</span>
                      }
                      @if ((row.clickCount ?? 0) > 0) {
                        <span class="text-violet-600 dark:text-violet-400">🖱 {{ row.clickCount }} click{{ (row.clickCount ?? 0) > 1 ? 's' : '' }}</span>
                      }
                      @if (row.lastOpenedAt) { <span>Último open: {{ formatDate(row.lastOpenedAt) }}</span> }
                      @if (row.recipientError && !isExclusionError(row.recipientError)) {
                        <span class="text-red-600 dark:text-red-400 truncate max-w-xs">⚠ {{ row.recipientError }}</span>
                      } @else if (row.emailError) {
                        <span class="text-red-600 dark:text-red-400 truncate max-w-xs">⚠ {{ row.emailError }}</span>
                      }
                    </div>
                  </div>
                  @if (row.idEmailMessage) {
                    <button class="rounded p-2 text-gray-400 hover:text-gray-700 dark:hover:text-gray-200">
                      <svg class="h-4 w-4 transition-transform" [class.rotate-180]="getState(row.id).isExpanded" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                      </svg>
                    </button>
                  }
                </div>

                @if (getState(row.id).isExpanded) {
                  <div class="border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/30 p-4">
                    @if (getState(row.id).detailLoading) {
                      <div class="space-y-2">
                        <div class="h-3 w-1/2 animate-pulse rounded bg-gray-200 dark:bg-gray-700"></div>
                        <div class="h-3 w-2/3 animate-pulse rounded bg-gray-200 dark:bg-gray-700"></div>
                        <div class="h-3 w-1/3 animate-pulse rounded bg-gray-100 dark:bg-gray-800"></div>
                      </div>
                    } @else if (getState(row.id).detail; as detail) {
                      <div class="grid grid-cols-1 gap-4 lg:grid-cols-3">
                        <div class="lg:col-span-2">
                          <h4 class="mb-2 text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">Eventos del tracking pixel</h4>
                          @if (!detail.events || detail.events.length === 0) {
                            <p class="text-xs text-gray-400">Sin eventos registrados todavía.</p>
                          } @else {
                            <ul class="space-y-2">
                              @for (ev of detail.events; track ev.occurredAt + ev.eventType) {
                                <li class="flex items-start gap-2 rounded-lg border border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800 p-2">
                                  <span class="text-base">{{ eventIcon(ev.eventType) }}</span>
                                  <div class="flex-1 min-w-0">
                                    <p class="text-sm font-medium text-gray-900 dark:text-white">{{ emailStatusLabel(ev.eventType) }}</p>
                                    <p class="text-xs text-gray-500 dark:text-gray-400">{{ formatDate(ev.occurredAt) }}</p>
                                  </div>
                                </li>
                              }
                            </ul>
                          }
                        </div>
                        <div class="space-y-3">
                          <div class="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-3">
                            <h5 class="text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">Métricas</h5>
                            <dl class="mt-2 space-y-1 text-xs">
                              <div class="flex justify-between gap-2">
                                <dt class="text-gray-500 dark:text-gray-400">Aperturas</dt>
                                <dd class="text-gray-900 dark:text-white">{{ row.openCount ?? 0 }}</dd>
                              </div>
                              <div class="flex justify-between gap-2">
                                <dt class="text-gray-500 dark:text-gray-400">Clics</dt>
                                <dd class="text-gray-900 dark:text-white">{{ row.clickCount ?? 0 }}</dd>
                              </div>
                              <div class="flex justify-between gap-2">
                                <dt class="text-gray-500 dark:text-gray-400">Entregado</dt>
                                <dd class="text-gray-900 dark:text-white">{{ formatDate(row.deliveredAt) }}</dd>
                              </div>
                              <div class="flex justify-between gap-2">
                                <dt class="text-gray-500 dark:text-gray-400">Primera apertura</dt>
                                <dd class="text-gray-900 dark:text-white">{{ formatDate(row.firstOpenedAt) }}</dd>
                              </div>
                              <div class="flex justify-between gap-2">
                                <dt class="text-gray-500 dark:text-gray-400">Última apertura</dt>
                                <dd class="text-gray-900 dark:text-white">{{ formatDate(row.lastOpenedAt) }}</dd>
                              </div>
                              <div class="flex justify-between gap-2">
                                <dt class="text-gray-500 dark:text-gray-400">Intentos</dt>
                                <dd class="text-gray-900 dark:text-white">{{ detail.attemptCount ?? 1 }}</dd>
                              </div>
                            </dl>
                          </div>
                          @if (detail.errorMessage) {
                            <div class="rounded-lg border border-red-200 bg-red-50 p-3 text-xs text-red-700 dark:border-red-700 dark:bg-red-900/20 dark:text-red-300 break-words">
                              {{ detail.errorMessage }}
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>

          @if (hasMore) {
            <div class="mt-4 flex justify-center">
              <button (click)="loadMore()" [disabled]="loading"
                      class="inline-flex items-center gap-2 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-60">
                @if (loading) {
                  <svg class="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Cargando…
                } @else {
                  Cargar más
                }
              </button>
            </div>
          }
        }
      </div>
    </div>
  }
</div>
